import defaultStyle from './defaultStyle.json';

export default { defaultStyle };
